import React, { useState, useContext, useEffect, Fragment } from "react";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import { EWContext } from "../../../context/EWContext";
import FormBuilder from "../FormBuilder/FormBuilder";
import { getFormAnswers } from "../../../utils/utils";
import { getMakes, getModels } from "../../../services/services";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import Backdrop from "../../../hoc/Backdrop/Backdrop";

function ProductInformationForm(props) {
    const [accountState, setAccountState] = useContext(
        EWContext
    );

    const {
      conditionSpecificBehaviors,
        customErrors,
        questions: {
          product: questions
        },
        answers: {
          product: answers
        },
        baseUrl,
        pimcore,
        version
    } = accountState;

    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [errorFields, setErrorFields] = useState(true);
    const [isValidForm, setIsValidForm] = useState(false);
    const [productFormAnswers, setProductFormAnswers] = useState(
      answers
    );
    const [makeOptions, setMakeOptions] = useState([]);
    const [productId, setProductId] = useState(pimcore?.productId || 1);
    const [modelNumberOptions, setModelNumberOptions] = useState([]);
    const [resetValues, setResetValues] = useState({});
    const errorInForm = useState({
        message: customErrors.genericError,
        genericMessage: customErrors.contactError,
        labelButton: "Back",
        error: false
    })[0];
    const [findModel, setFindModel] = useState("");
    const { group, handleNext, handleBack } = props;

    useEffect(() => {

      if(answers.length > 0) {
        let index = -1
        //checking if type is select and label is brand name to populate the value of modelSelect
        index = answers.findIndex(obj => obj.id === "brand_name" && obj.type === "select" );
        if(index >= 0 ) {
          getModelsCall(answers[index].value)
        }
      }

      setLoadingData(true);
      const measureInfoCall = async () => {
        const measureInfoResponse = await getMakes(
          baseUrl,
          customErrors.genericError,
          pimcore
        ).catch((error) => {
          // displayError();
          console.log(error);
          setLoadingData(false);
        });
        try {
          const makeOptions = measureInfoResponse?.data?.products &&
          measureInfoResponse.data.products.map(productmake => 
            ({ value: productmake.make, label: productmake.make }));

          setMakeOptions(makeOptions);
          setLoadingData(false);
        } catch (error) {
          // displayError();
          console.log(error);
          setLoadingData(false);
        }
      };
      measureInfoCall();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (answers.length > 0) {
            const formIsAnswered = answers.every((field) => {
              if(field.type === "date") {
                
                if(field.value == "Invalid Date") {
                  return false
                }
                let dateRange =  questions.find(ques => ques.id === field.id).field.rangeDates;

                if(dateRange?.minDate?.date) {

                  if(new Date(field.value ) < new Date(dateRange.minDate.date)){
                    return false
                  }
                } 

                if(dateRange?.maxDate?.date) {
                  if(new Date(field.value) > new Date(dateRange.maxDate.date)) {
                    return false
                  }
                }
              }
              return field ? (field.required && (field.type !== "hidden" && !field.disabled && field.type!== "reference") ? field.textValue !== "" : true) : false           
            });

            if (formIsAnswered) {
                setErrorFields(false);
            } else {
                setErrorFields(true);
            }
        } else {
            setErrorFields(true);
        }
    }, [answers]);

    /**Changing the In_compliance value from the checkbox */
    useEffect(() => {
      if(conditionSpecificBehaviors?.cr_incompliance_check){
        answers.forEach(incomplianceValue => {
          if(incomplianceValue.id === conditionSpecificBehaviors?.cr_incompliance_checkbox_id && incomplianceValue.value === true){
            incomplianceValue["value"]=conditionSpecificBehaviors?.cr_incompliance_checkbox_value;
            incomplianceValue["textValue"]=conditionSpecificBehaviors?.cr_incompliance_checkbox_value;
          }
        });
      }
      // eslint-disable-next-line
    }, [answers]);

    useEffect(() => {
        if (isValidForm) {
            // Saving answers in the App state
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                answers: {
                  ...prevAccountState.answers,
                  product: [...productFormAnswers]
                },
                submitAttempts: 0,
                callSavingsService: {
                  flag: true,
                  answers: "product"
                },
                pimcore: { ...prevAccountState.pimcore, productId }
            }));
            setLoading(false);
            handleNext(true);
        }
    }, [
        isValidForm,
        productFormAnswers,
        setAccountState,
        handleNext,
        productId
    ]);

    useEffect(() => {
        if (errorInForm.error) {
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                submitAttempts: prevAccountState.submitAttempts + 1,
                eligibilityError: errorInForm
            }));
        }
    }, [errorInForm, setAccountState]);

    const getModelsCall = async (make) => {
      setLoadingData(true);
      const modelsResponse = await getModels(
        baseUrl,
        customErrors.genericError,
        pimcore,
        make
      ).catch((error) => {
        console.log(error);
        setLoadingData(false);
        return;
      });
      try {
        let modelOptions = modelsResponse?.data?.products?.[0]?.models &&
        modelsResponse.data.products[0].models.map(model => 
          ({ value: model.pi_id, label: model.model_number }));

        let ifOtherOptionExists = modelOptions.findIndex(option => option.label === "OTHER")
        if(ifOtherOptionExists < 0) {            
          modelOptions.push({ value: `"${pimcore?.productId || 1}"`, label: "OTHER" })
        }
        setModelNumberOptions(modelOptions || []);
        setLoadingData(false);
      } catch (error) {
        console.log(error);
        setLoadingData(false);
      }
    };

    useEffect(() => {
      let delayDebounceFn;
      if (findModel.length > 0) {
        delayDebounceFn = setTimeout(() => {
          getModelsCall(findModel);
          // setLoadingData(false);
        }, 1000);
      }
      return () => clearTimeout(delayDebounceFn);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [findModel]);

    /**Function displayError for show the general error */
    const displayError = ( primaryErrorMessage, secondaryErrorMessage, customError) => {
      let errorInForm = {
        message: primaryErrorMessage,
        genericMessage: secondaryErrorMessage || customError,
        error: true
      }
      setAccountState((prevAccountState) => ({
        ...prevAccountState,
        ...{
          eligibilityError: errorInForm,
        },
      }));
    };

    /** function productEfficient on the basis of selection 2nd value check for hardstop */
    const productEfficient = (data) => {
      const questioncheck = (question) => questions.find(answer => answer.id === question);
      data.forEach((item) => {
        const { questionReview } = questioncheck(item.id);
        if(questionReview){
          const { firstQuestionId, secondQuestionId, errorMsg, rangeValue } = questionReview;
        if (item.id === firstQuestionId){
          data.forEach((filteranswer) => {
            if (filteranswer.id === secondQuestionId){
                const {dropdownVal,values}=questioncheck(filteranswer.id);
                let questionValue = "";
                for(let dropdownKey in dropdownVal){
                  if(item.value === dropdownKey){
                    questionValue=dropdownVal[dropdownKey]
                  }
                }
                for (const key in values) {
                  const valueKey = 'value' + key.slice(-1);
                  if (values.hasOwnProperty(key) && questionValue === values[key] && rangeValue) {
                    if (filteranswer.value >= parseFloat(values[valueKey])) displayError(errorMsg);
                  }else if (values.hasOwnProperty(key) && questionValue === values[key]) {
                    if (filteranswer.value <= parseFloat(values[valueKey])) displayError(errorMsg);
                  }
                }
            }
          });
        }
      }
      });
    };

    const handleOnFormAnswered = (answers, lastFieldModified) => {
      let newAnswers = {...answers};
      setResetValues({});
      // Checking for field brand_name to reset values from modelNumber field
      if (lastFieldModified?.id === "brand_name" && lastFieldModified?.textValue) {
        let defaultValue = { value: { value: "", label: ""}, textValue: ""};
        // setLoadingData(true);
        setFindModel(lastFieldModified.textValue);
        setResetValues({
          "model_number": defaultValue
        });
        newAnswers = {...answers, 'model_number' : defaultValue};
      }

      if (lastFieldModified?.id === "model_number" && lastFieldModified?.textValue) {
        let productIdTemp = 1
        if (lastFieldModified.value?.value > 0) {
          productIdTemp = lastFieldModified.value.value;
        } else if (lastFieldModified.value > 0) {
          productIdTemp = lastFieldModified.value;
        }
        setProductId(productIdTemp);
      }

      const formAnswers = getFormAnswers(newAnswers, questions, version, accountState);
      const formIsAnswered = formAnswers.every(
          (field) => {
              return field.required ? field.value !== "" : true;
          }
      );
      setProductFormAnswers(formAnswers);
      setAccountState((prevAccountState) => ({
          ...prevAccountState,
          answers: {
            ...prevAccountState.answers,
            product: [...formAnswers]
          },
      }));
      if (formIsAnswered) {
          setErrorFields(false);
      } else {
          setErrorFields(true);
      }
    };

  const handleSubmit = (evt) => {
    setLoading(true);
    evt.preventDefault();
    productEfficient(answers);
    if(conditionSpecificBehaviors?.electric_heater_fields){
    answers.forEach((resp)=>{
      if(resp?.id === 'electric_water_heater' && resp?.textValue === 'No') {
        let errorInForm = {
          message: 'Clothes washer rebates are not available for gas water heaters',
          genericMessage: '',
          error: true
        }
        setAccountState((prevAccountState) => ({
          ...prevAccountState,
          ...{
            eligibilityError: errorInForm,
          },
        }));
      }
    })
  }
    setIsValidForm(true);
  };



  const getCustomFieldOptions = () => {
    return {
      "brand_name": makeOptions,
      "model_number": modelNumberOptions
    }
  }

    return (
      <Fragment>
        <Backdrop open={loadingData}/>
        <FormBuilder
            questions={questions}
            answers={answers}
            onFormAnswered={handleOnFormAnswered}
            handleSubmit={handleSubmit}
            formInstructions={group.instructions}
            extraInfoAfterRequired={group.extraInfoAfterRequired}
            resetValues={resetValues}
            customConfig={
              {
                autocompleteOptions: getCustomFieldOptions(),
                dropdownOptions: getCustomFieldOptions()
              }
            }
        >
            <StepperNavigationButtons
                handleBack={handleBack}
                handleNext={() => null}
                loading={loading}
                nextButtonDisabled={errorFields}
            />
        </FormBuilder>
      </Fragment>
    );
}

export default withErrorHandler(ProductInformationForm);
